export default {
    env: process.env.NODE_ENV,
    apiEndpoint: process.env.REACT_APP_API_ENDPOINT,
    isAuthorized: false,
}
